import * as Mobx from 'mobx';
import { MessageStore } from '../Messages/Messages';
import { RootStore } from '../Root/RootStore';

export class ErrorsStore {
    @Mobx.observable public errors: any = Mobx.observable.object({});
    @Mobx.observable public errorObject: any = Mobx.observable.object({});
    
    public MessageStore: MessageStore;
    public RootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.RootStore = rootStore;
        this.MessageStore = this.RootStore.MessageStore;
    }
    
    public parse(errors: any) {

        for ( const prop in errors ) {
            if ( errors.hasOwnProperty(prop) ) {
                this.create(prop, errors[prop]);
            }
        }
        return true;
    }

    public guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
        return (s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()).replace(/-/g, '');
      }
    @Mobx.action
    public create(name: string, error: any) {
        const errors: any = Mobx.toJS(this.errors);
        let errorList: any = '';
        name = camelize(name);
        if ( !errors[name] ) {
            errors[name] = [];
        }
        
        if ( Array.isArray(error)) {
            if (error.length > 0) {

                errorList += name + ': ';
                for ( const err of error ) {
                    errors[name].push(err);
                    errorList += '<p>' + err + '</p>';
                }
                
                this.MessageStore.addMessage(errorList, 'danger');
            } else {
                delete errors[name];
            }
        } else {
            errors[name].push(error);
        }

        this.errors = errors;
    }
    @Mobx.action
    public addToErrors(ref: any, type: any, error: any) {
        const errors: any = Mobx.toJS(this.errorObject);

        if ( !errors[ref] ) {
            errors[ref] = [];
        }

        if ( errors[ref].indexOf(type) < 0 ) {
            errors[ref].push(type);
        }

        this.errorObject = errors;
    }

    public removeFromErrors(ref: any, type?: any) {
        const errors: any = Mobx.toJS(this.errorObject);
        
        if ( errors[ref] ) {
            if ( errors[ref].length <= 0 || type === undefined) {
                delete errors[ref];
            } else {
                const index = errors[ref].indexOf(type);
                
                if ( index > -1 ) {
                    errors[ref].splice(index, 1);
                    if ( errors[ref].length <= 0 || type === undefined) {
                        delete errors[ref];
                    }
                }
            }
            Mobx.runInAction(() => {
                this.errorObject = errors;
            });
        }
    }

    @Mobx.action
    public clearAll() {
        this.errors = Mobx.observable.object({});
    }
    @Mobx.action
    public clearAllErrors() {
        this.errors = Mobx.observable.object({});
        this.errorObject = Mobx.observable.object({});
    }

    public clearError(propName: any) {
        const errors: any = Mobx.toJS(this.errors);
        
        if ( errors.hasOwnProperty(propName) ) {
            delete errors[propName];
            Mobx.runInAction(() => {
                this.errors = errors;
            });
        }
    }

    public isEmpty(obj: any) {
        if ( obj instanceof Array ) {
            return ( obj.length <= 0 );
        }

        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        
        return true;
    }

    public allErrorsCleared() {
        return ( this.isEmpty(this.errorObject) && this.isEmpty(Mobx.toJS(this.errors)) );
    }

}

const camelize = (str:string) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
      if (+match === 0) {return "";} // or if (/\s+/.test(match)) for white spaces
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
};



// WEBPACK FOOTER //
// ./src/Stores/Errors/Errors.tsx